import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/siteData";

function Logo() {
  return (
    <a href="#top" className="flex items-center gap-2 cursor-pointer group">
      <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-500 text-background-50 font-heading font-black text-lg shadow-sm group-hover:bg-primary-600 transition-colors">
        九
      </span>
      <span className="font-heading font-extrabold text-xl tracking-tight text-foreground-950">
        九色爆料
        <span className="ml-2 hidden sm:inline-block align-middle rounded-full bg-accent-100 text-accent-800 text-[11px] font-medium px-2 py-0.5">
          LIVE
        </span>
      </span>
    </a>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Logo />

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                className="px-4 py-2 rounded-full text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#contact"
              className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-megaphone-line text-base w-4 h-4 flex items-center justify-center"></i>
              投稿互动
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden flex items-center justify-center w-10 h-10 rounded-md bg-background-100 text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={`ri-${open ? "close" : "menu"}-line text-xl w-6 h-6 flex items-center justify-center`}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/98 backdrop-blur-md px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
            >
              投稿互动
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}